var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "mainWrapper" },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("header-section", { on: { spread: _vm.spread } }),
          _vm._v(" "),
          _c(
            "el-main",
            {
              staticStyle: {
                padding: "0",
                overflow: "visible",
                background:
                  "radial-gradient(circle at bottom right, #003030 70%, #121312 100%)"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                        padding: "5%"
                                      },
                                      attrs: { span: 21, offset: 3 }
                                    },
                                    [
                                      _c("h1", { staticClass: "main-title" }, [
                                        _vm._v(
                                          "Help your clients stay ahead with access to off-the-plan properties\n                  "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center"
                                      },
                                      attrs: { span: 21, offset: "3" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "action-buttons",
                                          staticStyle: { width: "100%" }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "login-action-btn",
                                              attrs: { plain: "" },
                                              on: { click: _vm.redirectToB2B }
                                            },
                                            [_vm._v("Start Now")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "contact-up-btn",
                                              attrs: { type: "primary" },
                                              on: { click: _vm.contactUs }
                                            },
                                            [_vm._v("Contact Us")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("el-row", { staticStyle: { padding: "2%" } }, [
                                _c("div", { staticClass: "banner-container" }, [
                                  _c("img", {
                                    staticClass: "banner-image",
                                    attrs: {
                                      loading: "lazy",
                                      src: _vm.currentBannerImage,
                                      alt: "banner"
                                    }
                                  })
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "background-color": "#ffffff" },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "h1",
                              {
                                staticStyle: {
                                  color: "#003333",
                                  "font-size": "20px",
                                  padding: "10% 20% 0"
                                }
                              },
                              [_vm._v("Do you want to list your projects?")]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticClass: "register-section-wrapper",
                              attrs: { span: 24 }
                            },
                            [
                              _c("div", { staticClass: "register-section" }, [
                                _c(
                                  "div",
                                  { staticClass: "promo-item" },
                                  [
                                    _c("h3", [_vm._v("Developer ?")]),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("Want to know more?")]),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass:
                                          "contact-sales-btn green-btn",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: _vm.redirectToDeveloperAgent
                                        }
                                      },
                                      [_vm._v("Register")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticClass: "register-section-wrapper",
                              attrs: { span: 24 }
                            },
                            [
                              _c("div", { staticClass: "register-section" }, [
                                _c(
                                  "div",
                                  { staticClass: "promo-item" },
                                  [
                                    _c("h3", [_vm._v("Real Estate Agent ?")]),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("Want to know more?")]),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass:
                                          "contact-sales-btn green-btn",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: _vm.redirectToDeveloperAgent
                                        }
                                      },
                                      [_vm._v("Register")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0", height: "0" } },
            [_c("footer-section")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.requestToJoinDialogVisible
        ? _c("request-to-join-u-connect-corporate-dialog", {
            attrs: {
              "request-to-join-dialog-visible": _vm.requestToJoinDialogVisible
            },
            on: {
              onClose: function($event) {
                _vm.requestToJoinDialogVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d4433a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4433a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/mainLayout-Interim.vue
// module id = null
// module chunks = 